























import { computed, defineComponent } from "@vue/composition-api";
import { PurchasedFileDetails, PurchasedFileOwner } from "@scrile/api-provider/dist/api/PurchasedFileProvider";
import { isImageFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "PurchasesCreator",
  components: { BaseAvatar },
  props: {
    data: { type: Object as () => PurchasedFileOwner, required: true },
  },
  setup(props) {
    const thumbnails = computed(() => {
      const result: string[] = [];
      while (result.length < 2) {
        props.data.files.forEach((file: PurchasedFileDetails) => {
          isVideoFile(file)
            ? result.push(MediaFilesController.getVideoThumbnail(file.urlPart, "360p"))
            : isImageFile(file)
            ? result.push(MediaFilesController.getImageThumbnail(file.urlPart, "360p"))
            : result.push(`/img/content-preview-media.svg`);
        });
      }
      return result;
    });

    return { thumbnails };
  },
});
